import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/FixedAssetReqs/FixedAssetReqs'

function* createFixedAsset(action) {
    try {
        const result = yield call(req.createFixedAssetReq, action);
        if (result.success === true) {
            toast.success(result.message || "Asset created successfully");
            yield put({ type: types.CREATE_FIXED_ASSET_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CREATE_FIXED_ASSET_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to create asset");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CREATE_FIXED_ASSET_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* getFixedAssets(action) {
    try {
        const result = yield call(req.getFixedAssetsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_FIXED_ASSETS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_FIXED_ASSETS_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch assets");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_FIXED_ASSETS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* getDepreciationMethods(action) {
    try {
        const result = yield call(req.getDepreciationMethodsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_DEPRECIATION_METHODS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_DEPRECIATION_METHODS_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_DEPRECIATION_METHODS_FAILURE, message: e?.message });
    }
}

function* getFixedAssetCategories(action) {
    try {
        const result = yield call(req.getFixedAssetCategoriesReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_FIXED_ASSET_CATEGORIES_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_FIXED_ASSET_CATEGORIES_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_FIXED_ASSET_CATEGORIES_FAILURE, message: e?.message });
    }
}

function* getFixedAssetDetails(action) {
    try {
        const result = yield call(req.getFixedAssetDetailsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_FIXED_ASSET_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_FIXED_ASSET_DETAILS_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch asset details");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_FIXED_ASSET_DETAILS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* updateFixedAsset(action) {
    try {
        const result = yield call(req.updateFixedAssetReq, action);
        if (result.success === true) {
            toast.success(result.message || "Asset updated successfully");
            yield put({ type: types.UPDATE_FIXED_ASSET_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.UPDATE_FIXED_ASSET_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to update asset");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_FIXED_ASSET_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* deleteFixedAsset(action) {
    try {
        const result = yield call(req.deleteFixedAssetReq, action);
        if (result.success === true) {
            toast.success(result.message || "Asset deleted successfully");
            yield put({ type: types.DELETE_FIXED_ASSET_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.DELETE_FIXED_ASSET_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to delete asset");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.DELETE_FIXED_ASSET_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

export default function* FixedAssetSaga() {
    yield takeLatest(types.CREATE_FIXED_ASSET, createFixedAsset);
    yield takeLatest(types.GET_FIXED_ASSETS, getFixedAssets);
    yield takeLatest(types.GET_DEPRECIATION_METHODS, getDepreciationMethods);
    yield takeLatest(types.GET_FIXED_ASSET_CATEGORIES, getFixedAssetCategories);
    yield takeLatest(types.GET_FIXED_ASSET_DETAILS, getFixedAssetDetails);
    yield takeLatest(types.UPDATE_FIXED_ASSET, updateFixedAsset);
    yield takeLatest(types.DELETE_FIXED_ASSET, deleteFixedAsset);
}
